export const blogs = [
  {
    id: "java-exceptions",
    title: "Mastering Java Exception Handling",
    date: "Feb 10, 2026",
    summary: "A deep dive into Checked vs Unchecked exceptions and building custom exception handlers in Spring Boot.",
    file: "java-exceptions.md"
  },
  {
    id: "networking-basics",
    title: "Networking Essentials for Developers",
    date: "Feb 5, 2026",
    summary: "Understanding TCP/IP, Subnetting, and IP security for robust microservices communication.",
    file: "networking-basics.md"
  },
  {
    id: "how-the-internet-works",
    title: "How the Internet Works",
    date: "Feb 12, 2026",
    summary: "A deep dive into DNS, TCP/IP, and the journey of a packet across the globe.",
    file: "how-the-internet-works.md"
  },
  {
    id: "fedora-dev-setup",
    title: "Fedora Linux: A Developer's Paradise",
    date: "Jan 28, 2026",
    summary: "Why I switched to Fedora and how I automated my system configuration backups.",
    file: "fedora-dev-setup.md"
  }
];
